import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    basket: {},
    baskets: [],
  },
  mutations: {
    setBasket(state, payload) {
      state.basket = payload;
    },
    setBaskets(state, payload) {
      state.baskets = payload;
    },
  },
  actions: {
    async getBasket({ commit, rootState: { locations } }, { suffix = locations.suffix, id }) {
      commit('setBasket', {});
      try {
        const { data } = await HTTP.get(`${suffix}/basket/${id}`);
        commit('setBasket', data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getBaskets({ commit, rootState: { locations } }, {
      suffix = locations.suffix,
      id = null, machineId = null, state = null,
      operation = null, pageNum = 1, pageSize = 10,
    }) {
      try {
        const { data } = await HTTP.get(`${suffix}/basket`, {
          params: {
            suffix, id, machineId, state, operation, pageNum, pageSize,
          },
        });
        commit('setBaskets', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
